/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_ListingInputs */

const en_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Listing`)
};

const es_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear anuncio`)
};

const fr_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une annonce`)
};

const de_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat erstellen`)
};

const ja_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品を作成`)
};

const zh_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建商品`)
};

const ar_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء إعلان`)
};

const id_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Listing`)
};

const it_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Annuncio`)
};

const ru_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать объявление`)
};

const pt_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Anúncio`)
};

const ko_create_listing = /** @type {(inputs: Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 등록`)
};

/**
* | output |
* | --- |
* | "Create Listing" |
*
* @param {Create_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_listing = /** @type {((inputs?: Create_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_listing(inputs)
	if (locale === "es") return es_create_listing(inputs)
	if (locale === "fr") return fr_create_listing(inputs)
	if (locale === "de") return de_create_listing(inputs)
	if (locale === "ja") return ja_create_listing(inputs)
	if (locale === "zh") return zh_create_listing(inputs)
	if (locale === "ar") return ar_create_listing(inputs)
	if (locale === "id") return id_create_listing(inputs)
	if (locale === "it") return it_create_listing(inputs)
	if (locale === "ru") return ru_create_listing(inputs)
	if (locale === "pt") return pt_create_listing(inputs)
	return ko_create_listing(inputs)
});